import { render, staticRenderFns } from "./snackbarstore.vue?vue&type=template&id=d1327422"
import script from "./snackbarstore.vue?vue&type=script&lang=js"
export * from "./snackbarstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports